import Component from 'components/content/sections/learnMore/component';

Component.defaultProps = {};
export default Component;
